import { createRoot } from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { StrictMode } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import App from './App';

const theme = createTheme({
  typography: {
    fontFamily: 'Andale Mono',
  },
  palette: {
    primary: {
      main: '#c2302f',
    },
    success: {
      main: '#3c8e77',
    },
    secondary: {
      main: '#85b1e0',
    },
    info: {
      main: '#ffc33e',
    },
    warning: {
      main: '#f68b33',
    },
    error: {
      main: '#6A5FB5',
    },
  },
});

let container = document.getElementById('app');
let root = createRoot(container);
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <StrictMode>
      <App />
    </StrictMode>
  </ThemeProvider>,
);
